<template>
  <v-row class="body-1">
    <v-col md="6">
      <div>
        <v-icon small>mdi-headset</v-icon>
        {{ $t('queues.body.agents') }}: {{ totalAgents }}
      </div>
      <div>
        <v-icon small>mdi-pause-circle-outline</v-icon>
        {{ $t('queues.body.agentsPaused') }}: {{ agentsPaused }}
      </div>
      <div>
        <v-icon small :color="iconColorAgentsOnCalls">mdi-phone-in-talk</v-icon>
        {{ $t('queues.body.agentsOnCall') }}: {{ agentsOnCall }}
      </div>
      <div>
        <v-icon small :color="iconColorQueueCalls">mdi-account-circle</v-icon>
        {{ $t('queues.body.calls') }}: {{ callsNum }}
      </div>
    </v-col>
    <v-col md="6">
      <div>
        <v-icon small>mdi-check-circle</v-icon>
        {{ $t('queues.body.completed') }}: {{ queue.completed }}
      </div>
      <div>
        <v-icon small>mdi-history</v-icon>
        {{ $t('queues.body.abandoned') }}: {{ queue.abandoned }}
      </div>
      <div>
        <v-icon small>mdi-timer</v-icon>
        {{ $t('queues.body.holdtime') }}: {{ queue.holdtime | formatTime }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'queue-card-body',
  props: {
    queue: {
      type: Object,
      required: true
    }
  },
  computed: {
    callsNum: function () {
      return this.queue.calls?.length ?? 0
    },
    totalAgents: function () {
      return this.queue.agents?.length ?? 0
    },
    agentsPaused: function () {
      return this.queue.agents.reduce((n, a) => n + a.paused, 0)
    },
    agentsOnCall: function () {
      return this.queue.agents.reduce((n, a) => n + a.oncall, 0)
    },
    iconColorAgentsOnCalls: function () {
      return this.agentsOnCall > 0
        ? 'amber darken-2'
        : undefined
    },
    iconColorQueueCalls: function () {
      return this.queue.calls > 0
        ? 'blue darken-1'
        : undefined
    }
  }
}
</script>

<style scoped>
</style>
